const TRANSFER_ROLE_LABELS = {
  approver: '原审批人',
  cc: '原抄送人',
  execute: '原执行人'
};

export function parseAssigneeTransferMeta(raw) {
  if (!raw) return null;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) || null;
    } catch {
      return null;
    }
  }
  if (typeof raw === 'object') return raw;
  return null;
}

export function formatAssigneeDisplayName(task, role = 'approver') {
  const name = task?.assignee_name || '-';
  const meta = parseAssigneeTransferMeta(task?.assignee_transfer_meta);
  if (!meta?.from_user_name || meta.reason !== 'resignation_handover') {
    return name;
  }
  const roleLabel = TRANSFER_ROLE_LABELS[role] || '原处理人';
  return `${name}（${roleLabel}已离职：${meta.from_user_name}）`;
}
